// extracted by mini-css-extract-plugin
export default {"graph":"Graph__graph___C85E9","noGraphData":"Graph__noGraphData___Ynwdv"};